// Copyright 2023 Red Energy
// Pablo Sosa (psosa_ar@yahoo.com)
// 2023-04-21

import axiosInstance from 'axios'

// Allows to call the serving server for startup configuration
const axios = axiosInstance.create({
  baseURL: '/',
})

const startupEnvironment = async function getEnvironment() {
  console.log('Config.getEnvironment() before axios.get()')
  let oktaEnvironmentResponse = await axios.get('/v1.0/cip/setup/environment')
  // console.log('Config.getEnvironment() after axios.get()', JSON.stringify(oktaEnvironmentResponse, null, 3))
  let oktaEnvironment = oktaEnvironmentResponse.data

  let result = {
    oidc: {
      clientId: oktaEnvironment.appOktaClientId,
      issuer: oktaEnvironment.appOktaIssuer,
      redirectUri: oktaEnvironment.appOktaRedirectUri,
      scopes: ['openid', 'profile', 'email'],
    },
    resourceServer: {
      messagesUrl: oktaEnvironment.appApiUrl,
    },
  }

  console.log('Obtain the environment from the backend', result)
  return result
}
const environment = await startupEnvironment()
export default environment
